import { render, staticRenderFns } from "./messagesource.vue?vue&type=template&id=651a29f5&"
import script from "./messagesource.vue?vue&type=script&lang=ts&"
export * from "./messagesource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports